<template>
  <div class="container-popups-simples-form">
    <template v-if="internal_config">
      <sweet-modal ref="config" blocking width="50vw" v-on:close="close">
        <div class="">
          <p>{{ $t('ct-get-response-authentication-message') }}</p>
          <div class="d-flex align-items-end">
            <div class="form-group flex-1 mb-0">
              <label>API Token (
                <button class="btn btn-link p-0 m-0 d-inline-block"
                        onclick="window.open('https://app.getresponse.com/api','_blank');">
                  {{ $t('ct-get-response-get-my-api-token') }}
                </button>
                )
              </label>
              <div class="d-flex align-items-start">
                <div class="flex-1">
                  <input
                    id="getresponse-token"
                    v-model="internal_config.token"
                    class="form-control flex-1"
                    type="text"
                    :class="{
                      'is-valid' : internal_config.token && tokenIsValid,
                      'is-invalid' : typeof tokenIsValid === 'boolean' && !tokenIsValid
                    }"
                  />
                  <div class="invalid-feedback">{{ $t('ct-get-response-invalid') }}</div>
                  <div class="valid-feedback">{{ $t('ct-get-response-valid') }}</div>
                </div>
                <button
                  class="btn btn-secondary"
                  type="button"
                  style="min-height: 47px"
                  @click="loadCampaigns()"
                >{{ $t('ct-get-response-verify') }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <hr/>
        <div class="step-select-list steps d-none">
          <div class="d-flex align-items-center">
            <div class="form-group flex-1 mb-0">
              <label class="w-100">{{ $t('ct-get-response-select-a-list') }}</label>
              <select
                id="list-id"
                v-model="internal_config.listUid"
                class="list-group-get-response list-group form-control"
                onchange="$(this).removeClass('is-invalid')"
              ></select>
              <div class="invalid-feedback">{{ $t('ct-get-response-select-a-list') }}</div>
            </div>
            <div class="input-group-append mt-4">
              <button
                class="btn btn-secondary"
                type="button"
                @click="selectList()"
              >{{ $t('ct-get-response-select') }}
              </button>
            </div>
          </div>
          <hr/>
        </div>

        <div class="step-combine-fields steps d-none">
          <label class="w-100">{{ $t('ct-get-response-match-fields') }}</label>

          <div class="table-contact-form">
            <table class="table">
              <thead>
              <th scope="col">{{ $t('ct-type') }}</th>
              <th scope="col">{{ $t('ct-label') }}</th>
              <th scope="col">{{ $t('ct-target-field') }}</th>
              <th scope="col">
                <button class="btn btn-primary float-right text-uppercase" @click="openPopupField('text', 'text')">
                  <font-awesome-icon :icon="['fas', 'plus-circle']" class="font-awesome-icon mr-2"/>
                  {{ $t('ct-add-field') }}
                </button>
              </th>
              </thead>
              <tbody>
              <template v-if="internal_config.fields.length">
                <tr
                  v-for="(field,index) in internal_config.fields"
                  :class="{'animated flash': internal_config.fieldAnimated}"
                  @animationend="internal_config.fieldAnimated = false"
                >
                  <td>{{ field.field }}</td>
                  <td>{{ field.label }}</td>
                  <td>{{ field.target_field }}</td>
                  <td class="text-right">

                    <i v-tooltip="{content:$t('ct-option-down'),  class: 'tooltip-custom'}"
                       class="mdi mdi-chevron-down text-secondary"
                       @click="changePosition(index, index+1)"
                    />

                    <i v-tooltip="{content:$t('ct-option-up'),  class: 'tooltip-custom'}"
                       class="mdi mdi-chevron-up text-secondary"
                       @click="changePosition(index, index-1)"
                    />

                    <i v-tooltip="{content:$t('ct-option-edit'),  class: 'tooltip-custom'}"
                       class="mdi mdi-pencil text-primary"
                       @click="editField(field, index)"
                    />

                    <i v-if="!field.essential"
                       v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"
                       class="ct-icon-trash text-danger"
                       @click.prevent="removeField(index, 0)"
                    />
                  </td>
                </tr>
              </template>
              <tr v-else>
                <td class="text-center" colspan="4">
                  {{ $t('ct-fields-empty') }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <br>

          <div class="form-group">
            <label class="w-100">{{ $t('ct-get-response-day-of-cycle') }}:</label>
            <input v-model="internal_config.dayOfCycle" class="form-control" type="number">
            <small class="form-text text-muted">{{ $t('ct-get-response-day-of-cycle-msg') }}.</small>
          </div>

          <div class="form-group">
            <div class="w-100">{{ $t('ct-get-response-action') }}:</div>
            <div class="form-check form-check-inline">
              <input id="get-response-action-1" v-model="internal_config.action" class="form-check-input"
                     name="get-response-action-options"
                     type="radio" value="message">
              <label class="form-check-label" for="get-response-action-1">{{
                  $t('ct-get-response-success-message')
                }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input id="get-response-action-2" v-model="internal_config.action" class="form-check-input"
                     name="get-response-action-options"
                     type="radio" value="redirect">
              <label class="form-check-label" for="get-response-action-2">{{
                  $t('ct-get-response-redirect-url')
                }}</label>
            </div>
          </div>

          <div v-if="internal_config.action === 'message'" class="form-group">
            <label class="w-100">{{ $t('ct-get-response-success-message') }}</label>
            <input v-model="internal_config.successMessage"
                   class="form-control"
                   type="text"/>
          </div>

          <template v-else-if="internal_config.action === 'redirect'">
            <div class="form-group">
              <label class="w-100">{{ $t('ct-get-response-redirect-url') }}</label>
              <input id="redirect-url" v-model="internal_config.redirectUrl"
                     class="form-control"
                     onkeyup="$('#redirect-url').removeClass('is-invalid')" placeholder="Ex: https://www.builderall.com"
                     type="text"/>
              <div class="invalid-feedback">{{ $t('	ct-invalid-url') }}</div>
            </div>

            <div class="form-group">
              <div class="form-check form-check-inline">
                <input id="get-response-tab-1" v-model="internal_config.tab" class="form-check-input"
                       name="get-response-tab-options"
                       type="radio" value="same">
                <label class="form-check-label" for="get-response-tab-1">{{ $t('ct-open-in-same-page') }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input id="get-response-tab-2" v-model="internal_config.tab" class="form-check-input"
                       name="get-response-tab-options"
                       type="radio" value="blank">
                <label class="form-check-label" for="get-response-tab-2">{{ $t('ct-open-in-another-page') }}</label>
              </div>
            </div>
          </template>
        </div>

        <div class="text-right mt-3">
          <button slot="button"
                  :class="internal_config.listUid === '' ? 'btn-secondary disabled' : 'btn-success'"
                  class="btn focus" @click="save()"
          ><i class="svg-icon svgi-save"></i>{{ $t('ct-get-response-done') }}
          </button>
        </div>
      </sweet-modal>

      <sweet-modal ref="text" :title="$t('ct-config-field')" width="40vw">
        <div class="form-row">
          <template v-if="!internal_config.newField.essential">
            <div class="form-group col-12 col-sm-8">
              <label>{{ $t('ct-get-response-target-field') }}</label>
              <select
                v-model="internal_config.newField.target_field"
                class="form-control target-field"
                required="required"
                @change="changeFieldTargetId"
              >
                <option
                  v-for="(customField, index) in customFieldsList"
                  :key="index"
                  :data-ref="customField.customFieldsList"
                  :value="customField.name"
                >
                  {{ customField.name }}
                </option>
              </select>
            </div>

            <div class="form-group col-12 col-sm-4">
              <label>{{ $t('ct-type') }}</label>
              <p v-if="internal_config.newField.target_field_type"
              >{{ $t(`ct-input-${internal_config.newField.field}`) }}</p>
            </div>
          </template>

          <div class="form-group col-12 col-sm-3 d-none">
            <label>{{ $t('ct-tag') }}</label>
            <input v-model="internal_config.newField.tag" :class="{ 'is-invalid': errors.has('newField.tag')}"
                   class="form-control"
                   name="tag"
                   type="text" @keydown="errors.clear('newField.tag')"/>
            <span
              v-if="errors.has('newField.tag')"
              class="invalid-feedback"
              v-text="errors.get('newField.tag')"
            ></span>
          </div>

          <div class="form-group col-12 col-sm-5">
            <label>{{ $t('ct-label') }}</label>
            <input v-model="internal_config.newField.label" :class="{ 'is-invalid': errors.has('newField.label')}"
                   class="form-control" name="label"
                   type="text" @keydown="errors.clear('newField.label')"/>
            <span
              v-if="errors.has('newField.label')"
              class="invalid-feedback"
              v-text="errors.get('newField.label')"
            ></span>
          </div>

          <div class="form-group col-12 col-sm-3">
            <label>{{ $t('ct-default-value') }}</label>
            <input v-model="internal_config.newField.default_value" class="form-control" name="default_value"
                   type="text"/>
          </div>

          <div class="form-group col-12 col-sm-4">
            <label>{{ $t('ct-help-text') }}</label>
            <input v-model="internal_config.newField.help_text" class="form-control" name="help_text" type="text"/>
          </div>

          <div v-if="!internal_config.newField.essential" class="form-group col-12 col-sm-5">
            <label>{{ $t('ct-required') }}</label>
            <select v-model="internal_config.newField.required" class="form-control" name="required">
              <option value="yes">{{ $t('ct-yes') }}</option>
              <option value="no">{{ $t('ct-no') }}</option>
            </select>
          </div>

          <div v-if="internal_config.newField.required === 'no'" ref="visibilyField" class="form-group col-12 col-sm-7">
            <label>{{ $t('ct-visibility') }}</label>
            <select v-model="internal_config.newField.visibility" class="form-control" name="visibility">
              <option value="visible">{{ $t('ct-visible') }}</option>
              <option value="hidden">{{ $t('ct-hidden') }}</option>
            </select>
          </div>
        </div>

        <template v-if="['select', 'checkbox', 'radio', 'multiselect'].includes(internal_config.newField.field)">
          <div class="table-contact-form">
            <table class="table">
              <thead>
              <th>{{ $t('ct-value') }}</th>
              <th>{{ $t('ct-name') }}</th>
              <th class="text-center">{{ $t('ct-default-option') }}</th>
              <th v-if="!['single_select', 'checkbox', 'radio', 'multi_select'].includes(internal_config.newField.target_field_type)"
                  class="text-right">
                <button
                  v-if="internal_config.newField.default_value"
                  v-tooltip="{content:$t('ct-delete-default-value'),  class: 'tooltip-custom'}"
                  class="btn m-0 p-0"
                  @click="internal_config.newField.default_value = ''">
                  <i class="ct-icon-trash text-dark"/>
                </button>
                <button class="btn btn-primary ml-1" @click="openOptionPopup">
                  <font-awesome-icon :icon="['fas', 'plus-circle']" class="font-awesome-icon mr-2"/>
                  {{ $t('ct-add-option') }}
                </button>
              </th>
              </thead>
              <tbody>
              <template v-if="internal_config.newField.options.length">
                <tr v-for="(option,index) in internal_config.newField.options">
                  <td>{{ option.value }}</td>
                  <td>{{ option.name }}</td>
                  <td class="text-center">
                    <div class="form-check">
                      <input :id="'defaultOption' + index" v-model="internal_config.newField.default_value" :value="option.value"
                             class="form-check-input position-static" name="defaultOption"
                             type="radio">
                    </div>
                  </td>
                  <td v-if="!['single_select', 'checkbox', 'radio', 'multi_select'].includes(internal_config.newField.target_field_type)"
                      class="text-right">
                    <i v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"
                       class="ct-icon-trash text-danger"
                       @click="removeSelectOption(index,1)"
                    />
                  </td>
                </tr>
              </template>
              <tr v-else>
                <td class="text-center" colspan="4">
                  {{ $t('ct-options-empty') }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </template>

        <alert-box-component :with_icon="true" class="py-3 mt-2 w-100" type="warning">
          <p slot="content" class="w-100 m-0" v-text="$t('ct-get-response-alert-input')"/>
        </alert-box-component>

        <button
          slot="button"
          class="btn btn-outline-light"
          @click="$refs.text.close()"
        >{{ $t('ct-cancel') }}
        </button>
        <button
          slot="button"
          class="btn btn-success"
          @click="genField('text')"
        ><i class="svg-icon svgi-save"></i>{{ $t('ct-save') }}
        </button>
      </sweet-modal>

      <sweet-modal ref="option" :title="$t('ct-config-field')" width="40vw">
        <div class="form-row">
          <div class="form-group col-4">
            <label>{{ $t('ct-value') }}</label>
            <input ref="form_option_value" class="form-control" name="value" type="text"/>
          </div>

          <div class="form-group col-8">
            <label>{{ $t('ct-name') }}</label>
            <input ref="form_option_name" class="form-control" name="name" type="text"/>
          </div>
        </div>

        <button slot="button" class="btn btn-outline-light" @click="close('option')">{{ $t('ct-cancel') }}</button>
        <button slot="button" class="btn btn-success" @click="addOption"><i
          class="svg-icon svgi-save"></i>{{ $t('ct-save') }}
        </button>
      </sweet-modal>
    </template>
  </div>
</template>

<script>

import {SweetModal, SweetModalTab} from 'sweet-modal-vue';
import CheckFields from '../Fields/CheckFields';
import SelectFields from '../Fields/SelectFields';
import TextFields from '../Fields/Text';
import DateFields from '../Fields/DateFields';
import {getCampaigns, getFields} from '../../../../../js/services/editor/getresponse';
import AlertBoxComponent from "../../../../commons/AlertBoxComponent.vue";
import Errors from "../../../../../js/base/Errors";

export default {
  name: 'ConfigModals',
  components: {
    AlertBoxComponent,
    SweetModal,
    SweetModalTab,
    CheckFields,
    SelectFields,
    TextFields,
    DateFields
  },
  data() {
    return {
      internal_config: false,
      callback: false,
      customFieldsList: [],
      getResponseCustomFields: [],
      errors: new Errors(),
      tokenIsValid: null,
    };
  },
  methods: {
    init(config, callback = false, element) {
      this.internal_config = config;
      this.callback = callback;
      this.element = element;
      this.tokenIsValid = null;
    },
    open(modal) {
      if (modal === 'config') {
        if (this.internal_config.token !== '') {
          this.loadCampaigns();
        } else {
          this.stepValidation();
        }
        this.$refs.config.open();
      }
    },

    close() {
      if (this.internal_config.listUid === '') {
        this.stepValidation();
        $(this.element).detach();
      }

      if (this.internal_config.action == 'redirect' && !this.validURL(this.internal_config.redirectUrl)) {
        this.internal_config.action = 'message';
      }

      $(this.element).css({zIndex: this.internal_config.zIndex});
    },

    addOption() {
      let obj = {
        name: this.$refs.form_option_name.value,
        value: this.$refs.form_option_value.value
      };
      this.internal_config.newField.options.push(Object.assign({}, obj));
      this.$refs.option.close();

      this.reload();
    },

    removeOption(index, level) {
      if (level === 0) {
        this.internal_config.fields.splice(index, 1);
      } else {
        this.internal_config.newField.options.splice(index, 1);
      }

      this.reload();
    },

    changeFieldTargetId(e) {

      const data = this.getResponseCustomFields[e.target.value]

      this.internal_config.newField.target_field_id = data.customFieldId;
      this.internal_config.newField.target_field_type = data.fieldType

      var identifier = data.fieldType
      if (['single_select', 'multi_select'].includes(data.fieldType)) {
        if (data.fieldType === 'single_select') {
          identifier = 'select'
        } else if (data.fieldType === 'multi_select') {
          identifier = 'multiselect'
        }
      }

      this.internal_config.newField.options = []
      data.values.forEach((option) => {
        this.internal_config.newField.options.push({name: option, value: option, fixedOption: true})
      })

      this.internal_config.newField.field = identifier;
    },

    validURL(url) {
      var regexp = /^(?:(?:https?):\/\/)(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
      return regexp.test(url);
    },

    loadCampaigns() {
      this.getCampaigns();
      this.getFields();
    },

    stepValidation() {
      $('.steps').addClass('d-none');
      $('body').removeClass('loading');
    },
    stepSelectList() {
      $('.steps').addClass('d-none');
      $('.step-select-list').removeClass('d-none');
      $('body').removeClass('loading');
    },
    stepCombineFields() {
      $('.step-select-list').removeClass('d-none');
      $('.step-combine-fields').removeClass('d-none');
      $('body').removeClass('loading');
    },

    selectList() {
      this.internal_config.listUid = $('#list-id').val();
      this.stepCombineFields();
    },

    getFields() {
      getFields(this.internal_config.token)
        .then(res => {
          this.customFieldsList = res.data

          try {
            this.getResponseCustomFields = [];
            res.data.forEach(element => {
              const name = element['name']
              const data = {
                customFieldId: element['customFieldId'],
                fieldType: element['fieldType'],
                values: element['values']
              }

              this.getResponseCustomFields[element['name']] = data;
            });

            if (this.internal_config.listUid != '') {
              this.stepCombineFields();
            }
          } catch (e) {
            console.log('error get response getlists', res);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    getCampaigns() {
      $('.list-group-get-response').empty();
      let vm = this;

      this.$loading.show()

      getCampaigns(this.internal_config.token)
        .then(res => {
          this.tokenIsValid = true
          function containerList(name, ref) {
            return $('<option>')
              .attr('value', ref)
              .text(name);
          }

          try {
            res.data.forEach(element => {
              containerList(element['name'], element['campaignId'])
                .attr(
                  'selected',
                  vm.internal_config.listUid == element['campaignId']
                )
                .appendTo(
                  $(this.$el)
                    .find('.list-group-get-response')
                    .get(0)
                );
            });

            this.stepSelectList();
          } catch (e) {
            this.tokenIsValid = false
            this.stepValidation();
            this.$loading.hide()
          }
        })
        .catch(() => {
          this.tokenIsValid = false
          this.stepValidation();
          this.$loading.hide()
        });
    },

    save() {
      if (this.callback && typeof this.callback === 'function') {

        if (this.internal_config.listUid == "") {
          $("#list-id").addClass("is-invalid");
        } else if (this.internal_config.action == 'redirect' && !this.validURL(this.internal_config.redirectUrl)) {
          $("#redirect-url").addClass("is-invalid");
        } else {
          this.callback(this.internal_config);
          this.$refs['config'].close();
        }
      }
    },

    openOptionPopup() {
      this.$refs.form_option_name.value = '';
      this.$refs.form_option_value.value = '';
      this.$refs.option.open();
    },

    reload() {
      let config = this.internal_config;
      this.internal_config = Object.assign({}, this.internal_config, config);
    },

    addSelectOption() {
      let obj = {
        name: this.$refs.form_option_name.value,
        value: this.$refs.form_option_value.value
      };
      this.internal_config.newField.options.push(Object.assign({}, obj));
      this.$refs.option.close();
      this.reload();
    },

    removeSelectOption(index) {
      this.internal_config.newField.options.splice(index, 1);
      this.reload();
    },

    changePosition(index, newIndex) {
      if (newIndex >= this.internal_config.fields.length || newIndex < 0) {
        return;
      }
      this.internal_config.fields.splice(
        newIndex,
        0,
        this.internal_config.fields.splice(index, 1)[0]
      );
    },

    genField(val) {
      if (!this.internal_config.newField.target_field) {
        return;
      }

      if (this.internal_config.newField.status === 'add') {
        this.internal_config.fields.push(
          Object.assign({}, this.internal_config.newField)
        );
      }
      this.$refs[val].close();
    },

    editField(field) {
      this.internal_config.newField = field;

      this.internal_config.newField.status = 'edit';

      this.$refs['text'].open();
    },

    removeField(index) {
      this.internal_config.fields.splice(index, 1);
      this.reload();
    },

    openPopupField(val, field) {
      this.internal_config.newField = false;
      this.internal_config.newField = {};

      this.internal_config.newField.status = 'add';
      this.internal_config.newField.field = field;
      this.internal_config.newField.label = '';
      this.internal_config.newField.default_value = '';
      this.internal_config.newField.visibility = 'visible';
      this.internal_config.newField.required = 'no';
      this.internal_config.newField.options = [];
      this.internal_config.newField.help_text = '';

      this.$refs['text'].open();
    },

  }
};
</script>

<style lang="scss" scoped>
.btn-secondary.disabled, .btn-secondary:disabled, .btn-secondary.disabled:hover, .btn-secondary.focus {
  opacity: .4;
  box-shadow: none;
}

.preview .bt-sb:hover {
  cursor: pointer;
  background-color: var(--button-background-color--hover) !important;
  color: var(--button-text-color--hover) !important;
}

#getresponse-token {
  background-image: none !important;
}

.inputs-area > > > label {
  color: var(--button-text-color--hover) !important;
}

.bt-text-area.show-label {
  margin-top: 32px;
}

.sb-text {
  line-height: 25px;
}

.place-btn {
  text-align: center;
}

.bt-text-area {
  display: block;
  text-align: center;
}

[data-device="tablet"] .bt-text-area,
[data-device="mobile"] .bt-text-area {
  width: auto !important;
}

.horizontal-form {
  display: flex;
}


</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Forms/GetResponseForm/ConfigModals.vue